"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$propsToShare = options.propsToShare,
      propsToShare = _options$propsToShare === void 0 ? {} : _options$propsToShare;
  return function (_ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, ["children"]);

    var toShare = {};

    if (typeof propsToShare === "string") {
      var split = propsToShare.split(".");
      toShare[split.pop()] = (0, _lodash["default"])(props, propsToShare, propsToShare);
    } else if (Array.isArray(propsToShare)) {
      propsToShare.forEach(function (prop) {
        var split = prop.split(".");
        toShare[split.pop()] = (0, _lodash["default"])(props, prop, prop);
      });
    } else {
      for (var prop in propsToShare) {
        toShare[prop] = (0, _lodash["default"])(props, propsToShare[prop], propsToShare[prop]);
      }
    }

    return /*#__PURE__*/_react["default"].createElement(Component, props, _react["default"].Children.map(children, function (child) {
      return /*#__PURE__*/_react["default"].cloneElement(child, toShare);
    }));
  };
};

exports["default"] = _default;